import { COMPANY, IMG } from "../data/site";
import { PageHero, Section, Overline, EnquiryForm } from "../components/site/bits";
import { Reveal } from "../components/site/motion";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

const CARDS = [
  { icon: MapPin, label: "Office address", value: COMPANY.address },
  { icon: Phone, label: "Telephone", value: COMPANY.phone },
  { icon: Mail, label: "Email", value: COMPANY.email },
  { icon: Clock, label: "Opening hours", value: COMPANY.hours },
];

export default function Contact() {
  return (
    <>
      <PageHero overline="Contact Us" lines={["Let's start a", "conversation."]} image={IMG.office}
        intro="Whether you're a resident, referral partner, landlord or simply want to learn more — our team is here to help." />

      <Section>
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="grid gap-5 sm:grid-cols-2">
              {CARDS.map((c) => (
                <div key={c.label} className="rounded-2xl border border-brand-dark/10 bg-brand-surface p-6">
                  <c.icon className="h-6 w-6 text-brand-green" strokeWidth={1.5} />
                  <p className="mt-4 text-xs font-semibold uppercase tracking-wider text-brand-slate">{c.label}</p>
                  <p className="mt-1 text-brand-dark">{c.value}</p>
                </div>
              ))}
            </div>
            <div className="mt-6 overflow-hidden rounded-2xl border border-brand-dark/10">
              <iframe title="Shelterease office location" data-testid="google-map"
                src="https://www.google.com/maps?q=101%20Lockhurst%20Lane%20Coventry%20CV6%205SF&output=embed"
                className="h-72 w-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal><div className="rounded-3xl border border-brand-dark/10 bg-brand-surface p-8 md:p-12">
              <Overline>Send a message</Overline>
              <h2 className="mt-5 font-serif text-3xl text-brand-dark">How can we help?</h2>
              <div className="mt-8">
                <EnquiryForm kind="contact" testid="contact-form" submitLabel="Send message" fields={[
                  { name: "name", label: "Your name", required: true, placeholder: "Full name" },
                  { name: "email", label: "Email", type: "email", required: true, placeholder: "you@email.com" },
                  { name: "phone", label: "Phone", type: "tel", placeholder: "07000 000000" },
                  { name: "subject", label: "Subject", type: "select", required: true, placeholder: "Select a subject", options: ["General enquiry", "Referral", "Landlord", "Volunteering", "Business partnership", "Careers", "Other"] },
                  { name: "message", label: "Message", type: "textarea", required: true, placeholder: "How can we help?" },
                ]} />
              </div>
            </div></Reveal>
          </div>
        </div>
      </Section>
    </>
  );
}
